module.exports = __webpack_public_path__ + "img/Signature(ko)_Light.76983df4.svg";